import { appInitialLoad } from "@services/app";
import { Context } from "components/CMS/useStore";
import Home from "containers/CMS/home";
import BlogLayout from "layout/blog";
import { getClient } from "lib/sanity-server";
import { Blog } from "lib/sanity-types";
import { NextSeo } from "next-seo";

export const blogsQuery = `
{
  "blogs": *[_type == "blog" && status == "PUBLISHED" && fixTop == true] | order(_updatedAt desc) {
    _id,
    "slug": slug.current,
    title,
    "coverImage": coverImage.asset->url,
    "words": length(content), 
    "coverImageMetadata": coverImage.asset->metadata.dimensions,
    author->{
      _id,
      name,
      "avatar": avatar.asset->url,
    },
    date,
    "updatedAt": _updatedAt,
  }
}`;

export default function BlogPage({
  blogs,
  app,
  fetchData,
}: {
  blogs: Blog[];
} & { fetchData?: any; app: any }) {
  const seoAttr = getSeoAttr(blogs);
  const articleJsonAttr = getArticleJsonAttr(blogs);

  return (
    <Context.Provider
      value={{
        fetchData,
        app,
      }}
    >
      <BlogLayout>
        <NextSeo {...seoAttr} />
        <Home blogs={blogs} />
      </BlogLayout>
    </Context.Provider>
  );
}

export async function getStaticProps({ params, preview = false }) {
  const { blogs } = await getClient(preview).fetch(blogsQuery);

  let fetchData = {};

  const app = await appInitialLoad({});

  return {
    props: {
      fetchData,
      app,
      blogs,
    },
  };
}

function getSeoAttr(blogs) {
  return {
    title: "Printy6 Blog - Print on Demand for Ecommerce and Artist",
    description: "",
    canonical: "https://www.printy6.com/blog",
  };
}

function getArticleJsonAttr(blogs) {
  return {};
}
